import { BrowserRouter, Route, Routes, useLocation } from "react-router-dom";
import HomePage from "./home_page";
import PriceCards from "./price_cards";
import LogInPage from "./login_page";
import { AuthProvider } from "./global_varibles";
import OrderPage from "./create_order";
import ShowOrderedDetails from "./order_summary";
import ShowSavedOrderDetails from "./show_oreder_details";
import ShowOrders from "./show_orders";
import ShowNotications from "./show_notifications";
import DisplaySummaryData from "./monthly_summary";
import DisplayAdvanceSummaryData from "./advance_summary";
import EditOrder from "./edit_order";
import ShowUpdatedOrderedDetails from "./edit_order_summary";

function ShowOrderedDetailsWrapper() {
    const location = useLocation();
    const { ordered_details } = location.state || {};

    return <ShowOrderedDetails ordered_details={ordered_details} />;
}

function App() {
    return (
        <BrowserRouter>
            <AuthProvider>
                <Routes>
                    <Route path="/" element={<HomePage />} />
                    <Route path="/prices" element={<PriceCards />} />
                    <Route path="/login" element={<LogInPage />} />
                    <Route path="/order" element={<OrderPage />} />
                    <Route path="/monthly-summary" element={<DisplaySummaryData />} />
                    <Route path="/monthly-ad-summary" element={<DisplayAdvanceSummaryData />} />
                    <Route path="/notications" element={<ShowNotications />} />
                    <Route path="/show-orders" element={<ShowOrders />} />
                    <Route path="/order-details/:orderId" element={<ShowSavedOrderDetails />} />
                    <Route path="/edit-order/:ord_id" element={<EditOrder />} />
                    <Route path="/order-summary" element={<ShowOrderedDetailsWrapper />} />
                    <Route path="/summary" element={<ShowUpdatedOrderedDetails />} />
                </Routes>
            </AuthProvider>
        </BrowserRouter>
    );
}

export default App;
